var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-dialog',{attrs:{"max-width":"500px"},model:{value:(_vm.dialogDelete),callback:function ($$v) {_vm.dialogDelete=$$v},expression:"dialogDelete"}},[_c('DeleteCard',{attrs:{"title":"Doriți să ștergeți această cerere de modificare note cu toate înregistrările?"},on:{"cancel":_vm.cancelDelete,"confirm":_vm.confirmDelete}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }